import wwccQualificationService from '@/modules/auth/services/WWCCQualificationService';
import type { WWCCQualificationType } from '@/modules/auth/types/WWCCQualificationType';

export default function useWWCCQualificationTypes() {
  const wwccQualificationTypes = ref<WWCCQualificationType[]>([]);
  const fetching = ref(false);

  const getWWCCQualificationTypes = async (): Promise<WWCCQualificationType[]> => {
    if (fetching.value) return wwccQualificationTypes.value;

    wwccQualificationTypes.value = [];
    fetching.value = true;

    try {
      const { data } = await wwccQualificationService.getWWCCQualificationTypes();
      wwccQualificationTypes.value = data.value || [];
    } catch (error) {
      console.error('Error fetching WWCC qualification types:', error);
    } finally {
      fetching.value = false;
    }

    return wwccQualificationTypes.value;
  };

  return {
    wwccQualificationTypes,
    fetching,
    getWWCCQualificationTypes,
  };
} 